export const Icomoon = () => (
  <svg
    aria-hidden="true"
    style={{ height: 0, overflow: 'hidden', position: 'absolute', width: 0 }}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs></defs>
  </svg>
);
